import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { translateErrorMessage } from '../../../utils/language.utils';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrl: './forgot.component.scss',
  standalone: false,
})
export class ForgotComponent {
  // Variables
  public forgotForm: FormGroup;
  errorMessage = '';
  successMessage = '';

  constructor(private authService: AuthService) {
    this.createForm();
  }

  public forgotPassword() {
    if (!this.forgotForm.valid) {
      this.forgotForm.markAllAsTouched();
      console.error('Form not valid');
      return;
    }
    this.errorMessage = '';
    this.successMessage = '';
    this.authService
      .forgotPassword(this.forgotForm.value.email)
      .then(() => {
        this.successMessage = 'Die E-Mail wurde gesendet.';
      })
      .catch(error => {
        // show error alert
        this.errorMessage = translateErrorMessage(error.message);
        console.error('Forgot password error:', error);
      });
  }

  public createForm() {
    this.forgotForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }
}
